import type {
  CommendaAiLiveCard,
  CommendaAiQuestionAnswer,
} from './CommendaAiActionsContext';
import { QuestionPlanCard } from './QuestionPlanCard';
import { QuestionSelectCard } from './QuestionSelectCard';

interface QuestionDockedCardProps {
  card: CommendaAiLiveCard;
  isGenerating: boolean;
  onAnswer: (payload: {
    toolCallId: string;
    answers: CommendaAiQuestionAnswer[];
    text: string;
  }) => void;
}

/** Renders the question awaiting an answer, pinned above the composer so it stays put while the
 * conversation scrolls. Dispatches on how the answer is given, not on what it is about. */
export function QuestionDockedCard({
  card,
  isGenerating,
  onAnswer,
}: QuestionDockedCardProps) {
  const { toolCallId, ask, onDismiss } = card;

  if (ask.kind === 'approve_plan') {
    const [plan] = ask.questions;

    return (
      <QuestionPlanCard
        title={plan.question}
        summary={plan.helper}
        body={ask.planBody ?? ''}
        isDisabled={isGenerating}
        onAnswer={(answer) =>
          onAnswer({
            toolCallId,
            answers: [{ questionIndex: 0, chosen: [answer.chosen] }],
            text: answer.text,
          })
        }
        onClose={onDismiss}
      />
    );
  }

  return (
    <QuestionSelectCard
      isMultiSelect={ask.kind === 'multi_select'}
      questions={ask.questions}
      isDisabled={isGenerating}
      onAnswer={(answers) =>
        onAnswer({
          toolCallId,
          answers,
          // The transcript keeps a readable reply: what they chose, in their own words.
          text:
            answers.flatMap((answer) => answer.chosen).join(', ') ||
            'You decide, use your best judgment.',
        })
      }
      onClose={onDismiss}
    />
  );
}
